import { useEffect, useState } from "react";
import { loneReel } from "../../lib/flyerViewer";
import { fLong, fRange, plural } from "../../lib/format";
import { fetchSameFlyer, type SameFlyer } from "../../lib/showsPage";
import { useApp } from "../appState";
import { Flyer } from "../Flyer";
import { Sheet } from "../Sheet";

/** A flyer several shows share (a festival's lineup, a run of nights): the flyer and each show on it. The Wall's tap, option A (2026-09-11). */
export function FlyerSheet({ showId }: { showId: number }) {
  const { open, close, zoom, version } = useApp();
  const [d, setD] = useState<SameFlyer | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    fetchSameFlyer(showId)
      .then((x) => live && setD(x))
      .catch((e: Error) => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [showId, version]);

  const newest = d?.shows[0];
  const oldest = d?.shows[d.shows.length - 1];
  const title = newest ? (newest.event ?? newest.bill[0]?.name ?? "Flyer") : "Flyer";
  return (
    <Sheet title={title} label="Shows on this flyer" onClose={close}>
      {error && <p className="error">{error}</p>}
      {!d && !error && <p className="loading">Loading…</p>}
      {d && newest && oldest && (
        <>
          <div className="sh-top">
            <div>
              <Flyer url={d.image_url} alt={`Flyer for ${title}`} natural
                text={{ date: newest.date, bands: newest.bill.map((b) => b.name), venue: newest.venue }}
                onZoom={() => zoom(loneReel(d.image_url!, title,
                  `${plural(d.shows.length, "show")} · ${fRange(oldest.date, newest.date)}`))} />
            </div>
            <div>
              <div className="sh-num">{plural(d.shows.length, "show")}</div>
              <div className="sh-date">{fRange(oldest.date, newest.date)}</div>
              {newest.event && <span className="pill">{newest.event}</span>}
            </div>
          </div>
          <section>
            <p className="eyebrow">On this flyer</p>
            <div className="facts">
              {d.shows.map((s) => (
                <button type="button" key={s.id} onClick={() => open("show", s.id)}>
                  <span className="fk">{fLong(s.date)} · {s.venue}</span>
                  <span className="fv2">{s.bill[0]?.name ?? `#${s.number}`}</span>
                </button>
              ))}
            </div>
          </section>
        </>
      )}
    </Sheet>
  );
}
